import store from './store';
import {
  GENERAL_ADMIN,
  DISTRIBUTEUR_ADMIN,
  INDEPENDANT_SHOP_ADMIN,
  CHAIN_SHOP_ADMIN,
  FRANCHISE_SHOP_ADMIN
} from '../constants/admins';
import { ALLSHOP } from '../constants/dataConfig';
import { Cookies } from 'react-cookie';
import { getRoles } from '../apis/firebase';
import { ERROR_NO_ACCESS } from '../constants'
import { COMPANY_ADMIN } from 'src/constants/roles';
import _ from 'lodash'
import { isObjectNotEmpty } from './tools';

export const getUserPermissions = async (shopId) => {
  try {
    const { roles } = await getRoles();
    let userRole = roles[0]
    const isSuperAdmin = roles.includes(COMPANY_ADMIN);

    const shopAdminObject = _.find(roles, (role) => typeof role === 'object' && role.shopAdmin.includes(shopId))

    const isAdminOfThisShop = !!shopAdminObject

    const allowConnexion = isSuperAdmin || isAdminOfThisShop;

    const cookies = new Cookies();
    const expireDate = new Date();
    expireDate.setFullYear(expireDate.getFullYear() + 1);
    const cookieOptions = { expires: expireDate, path: '/' };

    cookies.set('allowConnexion', allowConnexion, cookieOptions);

    if (isSuperAdmin) {
      userRole = COMPANY_ADMIN
    } else if (isObjectNotEmpty(shopAdminObject)) {
      userRole = shopAdminObject
    }

    return {
      allowConnexion,
      isAdminOfThisShop,
      isSuperAdmin,
      roleForCompany: userRole,
      shopWhereTheUserIsAdmin: shopAdminObject,
    };
  } catch (error) {
    console.error('Error fetching user permissions:', error);
    throw ERROR_NO_ACCESS;
  }
};


export const checkAccess = (type, access) => {
  const {
    generalAdmin,
    chainShopAdmin,
    franchiseShopAdmin,
    independantShopAdmin
  } = store.getState().user;
  let allow = false;
  allow = chainShopAdmin ? CHAIN_SHOP_ADMIN[type][access] : allow;
  allow = franchiseShopAdmin && !allow ? FRANCHISE_SHOP_ADMIN[type][access] : allow;
  allow = independantShopAdmin && !allow ? INDEPENDANT_SHOP_ADMIN[type][access] : allow;
  allow = generalAdmin && !allow ? GENERAL_ADMIN[type][access] : allow;
  return allow;
}

export const handleShopsButton = (component, props) => {
  const { shopName } = props;
  const newAccesArray = [];
  newAccesArray.push(shopName);
  if (checkAccess('features', 'globalFinances')) {
    newAccesArray.push(ALLSHOP);
  }
  component.setState({
    accesArray: newAccesArray
  });
}